/* bOS time-of-day mode switcher.
   Schedule: day 08:00-16:59, evening 17:00-07:59.
   Manual override: ?bos-mode=day|evening, or localStorage 'bos-mode-override'. */

(function () {
  var SCHEDULE = {
    dayStart: { h: 8, m: 0 },
    eveningStart: { h: 17, m: 0 },
  };

  function minutesOfDay(date) {
    return date.getHours() * 60 + date.getMinutes();
  }

  function modeForDate(date) {
    var t = minutesOfDay(date);
    var dayT = SCHEDULE.dayStart.h * 60 + SCHEDULE.dayStart.m;
    var eveT = SCHEDULE.eveningStart.h * 60 + SCHEDULE.eveningStart.m;
    if (t >= eveT || t < dayT) return 'evening';
    return 'day';
  }

  function readOverride() {
    try {
      var url = new URL(window.location.href);
      var fromQuery = url.searchParams.get('bos-mode');
      if (fromQuery) {
        localStorage.setItem('bos-mode-override', fromQuery);
        return fromQuery;
      }
      return localStorage.getItem('bos-mode-override');
    } catch (e) {
      return null;
    }
  }

  function apply() {
    var override = readOverride();
    var mode = override || modeForDate(new Date());
    if (mode !== 'day' && mode !== 'evening') mode = 'day';
    document.documentElement.setAttribute('data-bos-mode', mode);
  }

  apply();

  setInterval(apply, 5 * 60 * 1000);

  window.bOS = window.bOS || {};
  window.bOS.setMode = function (mode) {
    if (mode === null || mode === undefined) {
      try { localStorage.removeItem('bos-mode-override'); } catch (e) {}
    } else {
      try { localStorage.setItem('bos-mode-override', mode); } catch (e) {}
    }
    apply();
  };
  window.bOS.currentMode = function () {
    return document.documentElement.getAttribute('data-bos-mode');
  };
})();
